export default __webpack_public_path__ + "static/media/telescopio.1f20a57a.png";